import { useMemo } from "react";
import { Box } from "@mui/material";
import MxDetailCardAgent, {
  MxDetailCardAgentProps
} from "@rf-l1/page/details/card-agents/MxDetailCardAgent";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import { formatPhoneNumberWithExtention } from "@/src-refactor/modules/shared/helpers/formar-phone-number-with-ext.helper";
import { redirectEmail } from "@/src-refactor/modules/shared/helpers/email.helper";
import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";

/**
 * PropertyAgentsCard
 *
 * Tarjeta que muestra los agentes captadores de la propiedad
 * con opciones de contacto por WhatsApp y email.
 */
const PropertyAgentsCard = () => {
  const { agents = [], id, isCollection, propertyType } = usePropertyDetailPage();

  const handleWhatsApp = (agent: any) => {
    const publicUrl = `${ENVIRONMENT_VAR.REMAX_DOMAIN}${
      isCollection ? "/collection" : ""
    }/propiedad/${propertyType
      ?.replaceAll(" ", "-")
      .replaceAll("/", "o")
      .toLowerCase()}/${id}`;

    const messageText = `${publicUrl}`;
    const link = `https://api.whatsapp.com/send?phone=1${encodeURIComponent(
      agent.phone ?? ""
    )}&text=${encodeURIComponent(messageText)}`;
    window.open(link, "_blank");
  };

  const handleEmail = (agent: any) => {
    redirectEmail(agent.email);
  };

  const agentsData: MxDetailCardAgentProps["agents"] = useMemo(
    () =>
      agents.map(agent => ({
        agencyName: agent.agencyName || "",
        email: agent.email || "",
        messageCallback: () => handleEmail(agent),
        WhatsappCallback: () => handleWhatsApp(agent),
        name: agent.name || "",
        picture: agent.picture || "",
        phone: formatPhoneNumberWithExtention(agent.phone ?? ""),
        getExtraDataCallback: () => agent
      })),
    [agents, id, isCollection, propertyType]
  );

  if (!agents || agents.length === 0) {
    return null;
  }

  return <MxDetailCardAgent agents={agentsData} title="Agentes" />;
};

export default PropertyAgentsCard;
